/* eslint-disable @typescript-eslint/no-magic-numbers, complexity, max-statements */
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { environment } from 'src/environments/environment'

import { ProfileDashboardModel } from '../../models/profile-response.model'
import { BuyButtonComponent } from './components/buy-button/buy-button.component'
import { DashboardStatsComponent } from './components/dashboard-stats.component'
import {
  Dashboard,
  WatchlistsItem,
  WatchlistsItemCategories,
} from './dashboard.model'
import { DashboardService } from './dashboard.service'
@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [],
})
export class DashboardComponent implements OnInit, OnDestroy {
  profileDashboardModel: ProfileDashboardModel
  dashboardModel: Dashboard
  stringModel: string
  dashboardSubscription: Subscription
  dashboardStats: DashboardStatsComponent
  hideAnnouncementBanner = true
  hideExpenseRatioBanner = false
  portIds: string
  expenseRatioFundIds: Array<string>
  allowedFundIds: Array<string>
  allowedFundIdsIsAEM = false
  announcementBanner: string
  expenseRatioBanner: string
  displayExpenseRatioBanner: boolean = false
  currentFundId: string
  caasContentLoaded: boolean
  buyButtonComponent: BuyButtonComponent
  content: object
  closedToAll: string
  closedToNew: string
  nonVgFundNotAvailable: string
  nonVgFundTransferOnly: string
  hideLegacyAnnouncementBanner = false
  hideNotAvailableAndTransferOnlyBanner = false
  advisedOnly: AEMChunk
  loadFund: string
  transactionFeeFund: string
  noTransactionFeeFund: string
  legacyLink: any
  lgfURL: any
  hideCloseToNewInvestorAnnouncementBanner = false
  subtitle: string
  aemContentSub: Subscription
  fundNonTransferableToVGIMsg: boolean
  nonFundAccessMsg: boolean
  dialogTitle: string
  noteText: string
  @ViewChild('simpleDialogContent') simpleDialogContent: TemplateRef<any>

  fundData: WatchlistsItem
  wlFundData: string

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit() {
    this.dashboardSubscription = new Subscription()

    this.dashboardSubscription = this.dashboardService
      .getProfileDashboardModel()
      .pipe(
        switchMap((profileModel) => {
          this.profileDashboardModel = profileModel
          if (!this.profileDashboardModel?.isFundAccessFund) {
            if (!this.profileDashboardModel.isFundTransferableToVGI) {
              this.fundNonTransferableToVGIMsg = true
            } else {
              this.nonFundAccessMsg = true
            }
          }
          return this.dashboardService.getDashboardModelData()
        }),
      )
      .subscribe((dashboardModel) => {
        this.dashboardModel = dashboardModel
        this.stringModel = JSON.stringify(dashboardModel)
        this.getDashboardContent()
        this.getWatchlistData()
      })
  }
  getDashboardContent() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }
  getWatchlistData() {
    const FUND_PROFILE_PATH = 'investment-products/mutual-funds/profile/'
    const ETF_PROFILE_PATH = 'investment-products/etfs/profile/'
    const PLAN_PROFILE_PATH = 'accounts-plans/529-plans/profile/'
    const profile = this.dashboardService.profileModel
    let url = FUND_PROFILE_PATH
    let category = WatchlistsItemCategories.VanguardMutualFund

    if (profile.isMutualFund) {
      url = environment.investorPrefix
        .concat(FUND_PROFILE_PATH)
        .concat(this.dashboardService.profileModel?.ticker.toLowerCase())
    } else if (profile.isETF) {
      category = WatchlistsItemCategories.VanguardETF
      url = environment.investorPrefix
        .concat(ETF_PROFILE_PATH)
        .concat(this.dashboardService.profileModel?.ticker.toLowerCase())
    } else if (profile.is529) {
      category = WatchlistsItemCategories.Other
      url = environment.investorPrefix
        .concat(PLAN_PROFILE_PATH)
        .concat(this.dashboardService.profileModel?.ticker.toLowerCase())
    }
    this.fundData = {
      label: profile?.shortName,
      cusip: profile?.cusip,
      ticker: profile?.ticker,
      category: category,
      link: url,
    }
    this.wlFundData = JSON.stringify(this.fundData)
  }
  isWatchListAvailable() {
    const profile = this.profileDashboardModel

    if (!profile) return false
    return (
      this.wlFundData &&
      !(profile.isExternalFund && profile.isETF) &&
      !profile.isExternalFund
    )
  }
  // eslint-disable-next-line complexity, max-statements
  parseAEMContent(content: any) {
    this.loadFund = this.centralContentService.getContentByBody(
      'fund_definitions_load',
      content,
    ).contentValue
    this.transactionFeeFund = this.centralContentService.getContentByBody(
      'fund_definitions_TF',
      content,
    ).contentValue
    this.noTransactionFeeFund = this.centralContentService.getContentByBody(
      'fund_definitions_NTF',
      content,
    ).contentValue
    this.closedToAll = this.centralContentService.getContentByBody(
      'banner_hard_closed_to_all_investors',
      content,
    )
    this.closedToNew = this.centralContentService.getContentByBody(
      'banner_soft_closed_to_new_investors',
      content,
    )

    this.nonVgFundNotAvailable = this.centralContentService.getContentByBody(
      'banner_non_vg_fund_not_available',
      content,
    )

    this.nonVgFundTransferOnly = this.centralContentService.getContentByBody(
      'banner_non_vg_fund_trasfer_only',
      content,
    )

    const fundIdsResponse = this.centralContentService.getContentByBody(
      'banner_announcements',
      content,
    )
    this.advisedOnly = this.centralContentService.getContentByBody(
      'configuration_vanguard_advised_only_icon',
      content,
    )
    const expenseRatioFundIds = this.centralContentService.getContentByBody(
      'banner_expense_ratio_fund_ids',
      content,
    )
    this.expenseRatioBanner = this.centralContentService
      .getContentByBody('banner_expense_ratio_announcements', content)
      .contentValue.toString()
    this.allowedFundIds = fundIdsResponse?.contentValue.toString().split('|')
    this.expenseRatioFundIds = expenseRatioFundIds?.contentValue
      .toString()
      .split(',')
    this.allowedFundIdsIsAEM = fundIdsResponse?.isAEM
    this.currentFundId = this.profileDashboardModel?.fundId
      ? this.profileDashboardModel['fundId']
      : '0000'
    this.alertByFundId(this.currentFundId)
    if (this.expenseRatioFundIds.includes(this.currentFundId)) {
      this.displayExpenseRatioBanner = true
    }
    this.lgfURL = this.currentFundId.concat('?FundIntExt=EXT')
    this.lgfURL = environment.investorPrefix
      .concat('mutual-funds/profile/')
      .concat(this.lgfURL)
    this.subtitle = this.dashboardService.getValidatedSubtitle(content)
  }

  public setDialogInfo(title = '') {
    this.dialogTitle = title
    if (this.dialogTitle === 'Load Funds') {
      this.noteText = this.loadFund
    }
    if (this.dialogTitle === 'TransactionFee Funds') {
      this.noteText = this.transactionFeeFund
    }
    if (this.dialogTitle === 'No-transaction-fee (NTF) funds') {
      this.noteText = this.noTransactionFeeFund
    }
  }

  alertByFundId(portId: string) {
    const charsNumber = 3
    this.allowedFundIds?.forEach((element) => {
      this.portIds = element.substring(0, element.indexOf('---'))
      if (portId === this.portIds) {
        element = this.centralContentService.formatLink(element)
        this.announcementBanner = element.substring(
          element.indexOf('---') + charsNumber,
        )
        this.hideAnnouncementBanner = false
      }
    })
  }

  closeNotAvailableAndTransferOnlyBanner() {
    this.hideNotAvailableAndTransferOnlyBanner = true
  }
  closeAnnouncementBanner() {
    this.hideAnnouncementBanner = true
  }
  closeExpenseRatioBanner() {
    this.hideExpenseRatioBanner = true
  }
  closeToNewInvestorAnnouncementBanner() {
    this.hideCloseToNewInvestorAnnouncementBanner = true
  }
  advisedBanner(fundId: string) {
    if (
      this.advisedOnly !== undefined &&
      this.advisedOnly.contentValue.indexOf(fundId) > -1
    ) {
      return true
    }
    return false
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
    this.dashboardSubscription.unsubscribe()
  }
  isBuyAvailable(): boolean {
    const profile = this.profileDashboardModel
    if (!profile) return false

    const isNotClosed = !profile.isClosed && !profile.isClosedToNewInvestors
    const isNot529 = !profile.is529
    const isAdvisedBanner = this.advisedBanner(profile.fundId)
    const isInternalFund = profile.isInternalFund
    const isExternalFundValid =
      profile.isExternalFund &&
      !this.fundNonTransferableToVGIMsg &&
      !this.nonFundAccessMsg &&
      isNotClosed
    const isExternalETF = profile.isExternalFund && profile.isETF
    return (
      isNotClosed &&
      isNot529 &&
      !isAdvisedBanner &&
      (isInternalFund || isExternalFundValid || isExternalETF)
    )
  }

  isCompareAvailable(): boolean {
    const profile = this.profileDashboardModel
    if (!profile) return false

    const isExternalFundValid =
      profile.isExternalFund &&
      !this.fundNonTransferableToVGIMsg &&
      !this.nonFundAccessMsg
    const isExternalETF = profile.isExternalFund && profile.isETF

    return (
      (profile.isInternalFund && !profile.is529) ||
      isExternalFundValid ||
      isExternalETF
    )
  }

  isFormattedForActionButtons(): boolean {
    return this.isBuyAvailable() || this.isCompareAvailable()
  }
}
